var React = require('react');

function Wave (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m0 1.32135029c1.80683619-1.76180039 5.41870713-1.76180039 7.22554332 0 1.80503475 1.76180039 5.41870708 1.76180039 7.22374188 0s5.4169057-1.76180039 7.2237419 0 5.4205086 1.76180039 7.2273447 0c1.8050348-1.76180039 5.4187072-1.76180039 7.2237419 0 1.8068362 1.76180039 5.4187072 1.76180039 7.2237419 0 1.8068362-1.76180039 5.4187071-1.76180039 7.2255433 0 1.8050348 1.76180039 5.4205086 1.76180039 7.2255433 0 1.8068362-1.76180039 5.4205086-1.76180039 7.2255434 0 1.8068361 1.76180039 5.4187071 1.76180039 7.2237418 0","fill":"none","transform":"translate(0 1)"}));
}

Wave.defaultProps = {"height":"5","viewBox":"0 0 73 5","width":"73"};

module.exports = Wave;

Wave.default = Wave;
